import React from 'react';

const QuickActionsBridgeContext = React.createContext(null);

export function QuickActionsBridgeProvider({ children }) {
  const [registry, setRegistry] = React.useState({}); // { sessions: {...}, members: {...} }

  const register = React.useCallback((key, api) => {
    if (!key) return () => {};

    setRegistry((prev) => ({
      ...prev,
      [key]: api,
    }));

    // unregister
    return () => {
      setRegistry((prev) => {
        const next = { ...prev };
        delete next[key];
        return next;
      });
    };
  }, []);

  const value = React.useMemo(() => ({ registry, register }), [registry, register]);

  return (
    <QuickActionsBridgeContext.Provider value={value}>
      {children}
    </QuickActionsBridgeContext.Provider>
  );
}

export function useQuickActionsBridge() {
  const ctx = React.useContext(QuickActionsBridgeContext);
  if (!ctx) {
    throw new Error('useQuickActionsBridge must be used within QuickActionsBridgeProvider');
  }
  return ctx;
}
